import {
  IOverlayRepository,
  OverlayEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class OverlayRepository implements IOverlayRepository {
  async getOverlayDefs(): Promise<ResponseValueObject<OverlayEntity[]>> {
    return new ResponseValueObject(true, [
      { type: 'agro', name: 'Cobertura agrícola', icon: 'sprout' },
      { type: 'hidrico', name: 'Recursos hídricos', icon: 'droplets' },
      { type: 'minero', name: 'Concesiones mineras', icon: 'pickaxe' },
      { type: 'conflicto', name: 'Conflictos sociales', icon: 'users' },
    ]);
  }
}
